/**
 * StoryboardCardList (v1.8.0) — vertical list of storyboard cards.
 * Each card displays its role, headline, takeaway and visual direction.
 * Read-only.
 */

import React from 'react';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import type { DesignAssetStoryboardCard } from '@segmently/schema-models/content-plan';

export interface StoryboardCardListProps {
  cards: DesignAssetStoryboardCard[];
}

export const StoryboardCardList: React.FC<StoryboardCardListProps> = ({ cards }) => {
  return (
    <Stack spacing={1} data-testid="design-brief-storyboard">
      <Typography variant="subtitle2">Storyboard</Typography>
      {cards.map((card, idx) => (
        <Paper
          key={card.cardIndex ?? idx}
          variant="outlined"
          sx={{ p: 1.5 }}
          data-testid={`design-brief-storyboard-card-${card.cardIndex ?? idx}`}
        >
          <Stack spacing={0.5}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip size="small" label={`#${(card.cardIndex ?? idx) + 1}`} />
              <Chip size="small" label={card.role ?? 'card'} variant="outlined" />
            </Stack>
            {card.headline && (
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {card.headline}
              </Typography>
            )}
            {card.userTakeaway && (
              <Typography variant="caption" color="text.secondary">
                {card.userTakeaway}
              </Typography>
            )}
            {card.visualDirection && (
              <Typography variant="caption">
                Visual: {card.visualDirection}
              </Typography>
            )}
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};
